import { Game, Player, VideoEvent } from "../client"
import { LEAGUE } from "../models/NBA"
import { SearchData } from "../models/SearchData"

export const defaultPlayer = (players: Player[], league: LEAGUE): Player => {
  const id = league === LEAGUE.NBA ? "201939" : "1628932" // Curry / A'ja
  const defaultPlayer = players.find(player => player.id === id)
  if (defaultPlayer) return defaultPlayer
  return players[0]
}

export const getGameString = (game: Game) => {
    return game ? `${new Date(game.date).toDateString()} | ${game.matchup}` : ''
}

export const buildSearchDescription = (data: SearchData): string => {
    // Player name
    let searchDescription = `${data.player.fullName} `

    // Stat Categories
    if (data.categories.length < 0) {
    } else if (data.categories.length === 0) {
        searchDescription += `pts `
    } else if (data.categories.length === 1) {
        searchDescription += `${data.categories[0]} `
    } else if (data.categories.length === 2) {
        searchDescription += `${data.categories[0]} and ${data.categories[1]} `
    }else if (data.categories.length > 0) {
        searchDescription += data.categories.slice(0,-1).map(stat => searchDescription += stat + ', ')
        searchDescription += `${data.categories.at(-1)} `
    } else {
        searchDescription += `pts `
    }

    // Last N Games
    const lastNGames = parseInt(data.lastNGames)
    if (lastNGames === 1) {
        searchDescription += `from last game. `
    } else {
        searchDescription += `from last ${lastNGames} games. `
    }

    // Date From and To
    if (data.dateFrom && data.dateTo) {
        searchDescription += `From ${data.dateFrom.getDate()} to ${data.dateTo.getDate()}`
    }

    return searchDescription
}

export const urlSafeBase64Encode = (str: string) => {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export const urlSafeBase64Decode = (str: string) => {
  const padded = str
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(str.length + (4 - str.length % 4) % 4, '=');
  
  return atob(padded);
}

export const sortVideos = (videos: VideoEvent[], desc: boolean = true): VideoEvent[] => {
  return [...videos].sort((a, b) => {
    const dateDiff = desc
      ? new Date(b.date).getTime() - new Date(a.date).getTime()
      : new Date(a.date).getTime() - new Date(b.date).getTime()

    if (dateDiff !== 0) return dateDiff
    if (a.gameId !== b.gameId) return a.gameId.localeCompare(b.gameId)
    return a.eventNumber - b.eventNumber
  })
}